import axios from 'axios';

export default axios.create({
    baseURL: process.env.REACT_APP_APIURL,
    headers: {"arixauth" : localStorage.getItem("arixauth") , "autho" : localStorage.getItem("autho")},
  });